/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * @file ScrollContainer.jsx
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.1
 */

import React from 'react';
import PropTypes from 'prop-types';

import { Scrollbars } from 'react-custom-scrollbars';

/**
 * Customizing the render view of Scrollbars component
 *
 */
const ScrollBarsRenderView = ({
  style,
  ...props
}) => {
  const customStyle = {
    overscrollBehavior: 'contain' // this is to overcome the `scroll chaining`
  };

  return (
    <div
      {...props}
      style={{ ...style, ...customStyle }}
    />
  );
};

ScrollBarsRenderView.propTypes = {
  style: PropTypes.object
};

ScrollBarsRenderView.defaultProps = {
  style: {}
};

const ScrollContainer = ({ children, onScroll, computedMaxHeight }) => (
  <Scrollbars
          // This will activate auto hide
    autoHide
          // Hide delay in ms
    autoHideTimeout={1000}
    id="resources-menu-scroll"
          // Duration for hide animation in ms.
    autoHideDuration={200}
    onScroll={onScroll}
    renderThumbHorizontal={(scrollProps) => <div {...scrollProps} className="resource-thumb-horizontal" />}
    renderThumbVertical={(scrollProps) => <div {...scrollProps} className="resource-thumb-vertical" />}
    renderView={ScrollBarsRenderView}
    autoHeight={!!computedMaxHeight}
    autoHeightMax={computedMaxHeight || null}
  >

    {children}
  </Scrollbars>
);

ScrollContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  computedMaxHeight: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf([null])
  ]),
  onScroll: PropTypes.func
};

ScrollContainer.defaultProps = {
  children: null,
  computedMaxHeight: null,
  onScroll: () => {}
};

export default ScrollContainer;
